import clsx from 'clsx'
import { MessageSquareShare } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { FormattedText } from '../../../components'
import { WhatsAppContentProps } from './WhatsAppContent'

export function WhatsAppContentTemplate (props: WhatsAppContentProps) {
  const { className, content, contentData } = props

  const { t } = useTranslation('whatsAppMessageContent')
  const templateName = contentData?.template?.name

  return (
    <>
      {content && (
        <div className={clsx(className, 'text-sm px-1')}>
          <div className="text-sm text-gray-400 italic">
            <span>Template message</span>
            <span className="text-xs">: {templateName}</span>
          </div>
          <FormattedText text={content} />
        </div>
      )}
      {!content && (
        <div className="flex flex-row gap-2 p-2">
          <div className="w-fit p-2 rounded-lg bg-[#abf6db]">
            <MessageSquareShare size={20} className="text-[#125d42]" />
          </div>
          <div className="flex flex-col">
            <span className="text-sm text-gray-400 italic">{t('Template message')}</span>
            <span className="text-xs">{templateName}</span>
          </div>
        </div>
      )}
    </>
  )
}
